import React, { Component } from 'react'
import { reduxForm } from 'redux-form'

import validate from 'utils/validate'

import FIELDS from './fields'
import PromoCodeForm from './promo-code-form'

const FIELD_NAMES = FIELDS.map(field => field.name)

class PromoCodeFormContainer extends Component {
  render() {
    return <PromoCodeForm {...this.props} />
  }
}

export default reduxForm({
  form: 'promoCode',
  fields: FIELD_NAMES,
  validate: validate(FIELDS),
})(PromoCodeFormContainer)



/** WEBPACK FOOTER **
 ** ./src/components/promo-code-form/promo-code-form-container.js
 **/